// extracted by mini-css-extract-plugin
export default {"container":"CarouselWrapper_container__j7X-7","slickArrow":"CarouselWrapper_slickArrow__BB2S2"};